export default __webpack_public_path__ + "static/media-ministry-of-health-dca7afaed0fc17c2783ee7e77b9b07a2.png";